import { MenuItem, Paper, Popper, TextField } from '@mui/material'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { metodoPrograma } from '../../../../components/api'

export const InputViaAdministracao = ({ medicamento, setMedicamento }) => {
  const [listMedicamentos, setListMedicamentos] = useState([])
  const medicamentosFiltrados = useMemo(() => {
    const busca = medicamento.forma.trim().toLowerCase()
    return listMedicamentos
      .filter((medicamento) => {
        const forma = medicamento[1]?.toLowerCase()
        return forma.includes(busca)
      })
      .slice(0, 15)
  }, [listMedicamentos, medicamento.forma])

  const [anchorEl, setAnchorEl] = useState(null)

  const getMedicamentos = useCallback(async () => {
    const res = await metodoPrograma('buscaViaAdministracao', {})
    if (res.status) {
      setListMedicamentos(res.lista)
    }
  }, [])

  const handleSelectOption = (value) => {
    if (!value) return
    setMedicamento({
      ...medicamento,
      idVia: value[0],
      forma: value[1],
    })
  }

  const handleBlur = () => {
    setTimeout(() => {
      setAnchorEl(null)
    }, 200)
  }

  useEffect(() => {
    getMedicamentos()
  }, [getMedicamentos])

  return (
    <>
      <TextField
        variant="outlined"
        margin="dense"
        label="Administração"
        onFocus={(e) => setAnchorEl(e.currentTarget)}
        onBlur={handleBlur}
        value={medicamento.forma}
        fullWidth
        onChange={(e) =>
          setMedicamento({
            ...medicamento,
            forma: e.target.value,
          })
        }
      />
      <Popper
        style={{
          zIndex: 2000,
          maxHeight: '200px',
          overflowY: 'auto',
          minWidth: anchorEl ? anchorEl.offsetWidth : '200px',
        }}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        disablePortal
      >
        <Paper style={{ width: '100%' }}>
          {medicamentosFiltrados.map((option) => (
            <MenuItem
              key={option[0]}
              id={`paciente-option-${option[0]}`}
              onClick={() => handleSelectOption(option)}
            >
              {option[1]}
            </MenuItem>
          ))}
        </Paper>
      </Popper>
    </>
  )
}
